// extracted by mini-css-extract-plugin
export default {"notFoundContainer":"NotFound_notFoundContainer__Adf7N","title":"NotFound_title__D8KzW","message":"NotFound_message__obVKA","homeLink":"NotFound_homeLink__dOHts"};